<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '命令详情'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="60%"
    top="5vh"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="border-style">命令信息</div>
    <el-form :model="item" ref="itemform" label-width="140px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="命令名称" prop="Name">
            <span slot="label">
              <span>
                <span
                  >命令名称
                  <el-popover
                    placement="top-start"
                    width="250"
                    trigger="hover"
                    content=""
                    ><div>用于命令按钮名称,建议6个字以内</div>
                    <i
                      slot="reference"
                      class="el-icon-info"
                      style="color: #409eff"
                    ></i>
                  </el-popover>
                </span>
              </span>
            </span>
            <el-input
              v-model.trim="item.Name"
              placeholder="请输入命令名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="命令主题" prop="Title">
            <el-input
              v-model.trim="item.Title"
              placeholder="请输入命令主题"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="命令等级" prop="CommandGradeID">
            <span slot="label">
              <span>
                <span
                  >命令等级
                  <el-popover
                    placement="top-start"
                    width="250"
                    trigger="hover"
                    content=""
                    ><div>
                      通用、企业、运维类型用于预警平台，配合公开命令一起使用
                    </div>
                    <i
                      slot="reference"
                      class="el-icon-info"
                      style="color: #409eff"
                    ></i>
                  </el-popover>
                </span>
              </span>
            </span>
            <select2
              style="width: 100%"
              v-model="item.CommandGradeID"
              url="basic?type=CommandGrade"
              :clearable="false"
              placeholder="请选择命令等级"
              :emptyValue="0"
              :currentList="currentCommandGrade"
            ></select2>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否公开" prop="IsPublic">
            <span slot="label">
              <span>
                <span
                  >是否公开
                  <el-popover
                    placement="top-start"
                    width="250"
                    trigger="hover"
                    content=""
                    ><div>
                      公开给外部用户使用的控制命令,可通过快捷按钮发送命令
                    </div>
                    <i
                      slot="reference"
                      class="el-icon-info"
                      style="color: #409eff"
                    ></i>
                  </el-popover>
                </span>
              </span>
            </span>
            <el-radio-group v-model="item.IsPublic">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否二次确认" prop="IsSecondConfirmation" v-if="item.IsPublic">
            <span slot="label">
              <span>
                <span
                  >是否二次确认
                  <el-popover
                    placement="top-start"
                    width="250"
                    trigger="hover"
                    content=""
                    ><div>
                      公开给外部用户使用的，使用前需要用户二次确认，并可批配置二次确认提示信息
                    </div>
                    <i
                      slot="reference"
                      class="el-icon-info"
                      style="color: #409eff"
                    ></i>
                  </el-popover>
                </span>
              </span>
            </span>
            <el-radio-group v-model="item.IsSecondConfirmation">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="二次确认提示信息" prop="SecondConfirmationDesc" v-if="item.IsSecondConfirmation">
           <!-- :rules="[{required: item.IsSecondConfirmation == 1, message: '二次确认提示信息必填', trigger: 'blur'}]" -->
            <el-input
              v-model.trim="item.SecondConfirmationDesc"
              :autosize="{ minRows: 1 }"
              type="textarea"
              placeholder="请输入二次确认提示信息"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="命令内容" prop="Payload">
        <span slot="label">
          <span>
            <span
              >命令内容
              <el-popover
                placement="top-start"
                width="250"
                trigger="hover"
                content=""
                ><div>
                  JSON格式,如:{"com":"rshell","method":{"runsh":"date","replyBytes":350}}
                </div>
                <i
                  slot="reference"
                  class="el-icon-info"
                  style="color: #409eff"
                ></i>
              </el-popover>
            </span>
          </span>
        </span>
        <el-input
          v-model.trim="item.Payload"
          :autosize="{ minRows: 5 }"
          type="textarea"
          placeholder="请输入命令内容"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="提示信息" prop="Desc">
        <el-input
          v-model.trim="item.Desc"
          :autosize="{ minRows: 1 }"
          type="textarea"
          placeholder="请输入提示信息"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="额外参数索引" prop="ExtraIndex">
        <span slot="label">
          <span>
            <span
              >额外参数索引
              <el-popover
                placement="top-start"
                width="250"
                trigger="hover"
                content=""
                ><div>
                  相关额外参数列表数据填写后拼装到命令内容中的字段中，如：runsh
                </div>
                <i
                  slot="reference"
                  class="el-icon-info"
                  style="color: #409eff"
                ></i>
              </el-popover>
            </span>
          </span>
        </span>
        <el-input
          v-model.trim="item.ExtraIndex"
          placeholder="请输入额外参数索引"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div class="border-style">额外参数列表</div>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateParamsClick">
        <i class="fas fa-plus"></i> 新增参数
      </el-button>
    </div>
    <el-table :data="paramsList" v-loading="loading">
      <el-table-column prop="key_cn" label="显示名称" width="160" />
      <el-table-column prop="key_en" label="参数名称" width="160" />
      <el-table-column prop="value_type" label="参数类型" width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.value_type">
            <div v-for="obj in ParamsTypeOptions" :key="obj.value">
              <div v-if="obj.value === scope.row.value_type">
                {{ obj.label }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="data_source" label="数据源">
        <template slot-scope="scope">
          {{ scope.row.data_source }}
        </template>
      </el-table-column>
      <el-table-column prop="is_null" label="是否必填" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_null === true" type="warning"> 否 </el-tag>
          <el-tag v-else type="success"> 是 </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditParamsClick(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteParams(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>

    <el-dialog
      title="参数信息"
      :visible.sync="paramsVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="onCloseParamsItem"
      width="40%"
    >
      <el-form
        ref="paramsItemForm"
        label-width="120px"
        :model="paramsItem"
        :rules="paramsRules"
      >
        <el-form-item label="显示名称" prop="key_cn">
          <el-input
            v-model.trim="paramsItem.key_cn"
            placeholder="请输入显示名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="参数名称" prop="key_en">
          <el-input
            v-model.trim="paramsItem.key_en"
            placeholder="请输入参数名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="参数编码" prop="code">
          <span slot="label">
            <span>
              <span
                >参数编码
                <el-popover
                  placement="top-start"
                  width="250"
                  trigger="hover"
                  content="仅开发人员使用,开发中用于识别命令内容中特殊参数进行个性化处理,如远程端口转发命令中,TargetPort参数需要服务器自动分配空闲端口"
                >
                  <i
                    slot="reference"
                    class="el-icon-info"
                    style="color: #409eff"
                  ></i>
                </el-popover>
              </span>
            </span>
          </span>
          <el-input
            v-model.trim="paramsItem.code"
            placeholder="请输入参数编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="参数类型" prop="value_type">
          <el-select
            v-model="paramsItem.value_type"
            placeholder="请选择参数类型"
            style="width: 100%"
          >
            <el-option
              v-for="type in ParamsTypeOptions"
              :key="type.value"
              :label="type.label"
              :value="type.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否必填" prop="is_null">
          <el-radio-group v-model="paramsItem.is_null">
            <el-radio :label="false">是</el-radio>
            <el-radio :label="true">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="数据源" prop="data_sourcestr">
          <span slot="label">
            <span>
              <span
                >数据源
                <el-popover
                  placement="top-start"
                  width="250"
                  trigger="hover"
                  content=""
                  ><div>
                    对应参数类型中下拉框、单选框、多选框等,填写key,value的JSON格式。<br />
                    如:[{"key":"Daily","value":"日数据"},{"key":"Minutely","value":"分钟数据"},{"key":"Realtime","value":"实时数据"},{"key":"Hourly","value":"小时数据"}]
                  </div>
                  <i
                    slot="reference"
                    class="el-icon-info"
                    style="color: #409eff"
                  ></i>
                </el-popover>
              </span>
            </span>
          </span>
          <el-input
            v-model.trim="paramsItem.data_sourcestr"
            :autosize="{ minRows: 5 }"
            type="textarea"
            placeholder="数据源请输入JSON格式"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseParamsItem">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onConfirmParamsItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        Name: [
          { required: true, message: "命令名称不能为空", trigger: "blur" },
        ],
        Title: [
          { required: true, message: "命令主题不能为空", trigger: "blur" },
        ],
        CommandGradeID: [
          { required: true, message: "命令等级不能为空", trigger: "blur" },
        ],
        // Payload: [
        //   { required: true, message: "命令内容不能为空", trigger: "blur" },
        // ],
        IsPublic: [
          { required: true, message: "是否公开不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
      currentCommandGrade: [], //当前命令等级

      //=================额外参数===============
      ParamsTypeOptions: [
        { label: "文本", value: "input" },
        { label: "下拉框", value: "select" },
        { label: "单选框", value: "radio" },
        { label: "多选框", value: "checkbox" },
        { label: "数字框", value: "input-number" },
        { label: "年", value: "yy" },
        { label: "年月", value: "yy-MM" },
        { label: "年月日", value: "yy-MM-dd" },
        { label: "年月日时分秒", value: "yy-MM-dd HH:mm:ss" },
      ],
      paramsList: [], //额外参数列表
      loading: false,
      paramsVisible: false,
      paramsItem: {},
      paramsRules: {
        key_cn: [
          { required: true, message: "显示名称不能为空", trigger: "blur" },
        ],
        key_en: [
          { required: true, message: "参数名称不能为空", trigger: "blur" },
        ],
        value_type: [
          { required: true, message: "参数类型不能为空", trigger: "blur" },
        ],
        is_null: [
          { required: true, message: "是否必填不能为空", trigger: "blur" },
        ],
      },
      maxNum: 0, //记录参数最大数
      payload: [], //命令内容JSON
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      this.paramsList = [];
      if (this.item.ID) {
        if (this.item.CommandGrade != null) {
          this.currentCommandGrade = [
            { ID: this.item.CommandGradeID, Name: this.item.CommandGrade.Name },
          ];
        }
        if (this.item.ExtraParams != null && this.item.ExtraParams.length > 0) {
          this.maxNum = this.item.ExtraParams.length;
          for (let index = 0; index < this.item.ExtraParams.length; index++) {
            let element = this.item.ExtraParams[index];
            this.paramsList.push({
              id: index + 1,
              key_cn: element.key_cn,
              key_en: element.key_en,
              code: element.code,
              value_type: element.value_type,
              is_null: element.is_null,
              data_source: element.data_source,
            });
          }
        }
      }
    },
    onClose() {
      this.paramsList = [];
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    //新增或修改命令
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }

        //额外参数保存
        this.item.ExtraParams = [];
        for (let index = 0; index < this.paramsList.length; index++) {
          let element = this.paramsList[index];
          this.item.ExtraParams.push({
            key_cn: element.key_cn,
            key_en: element.key_en,
            code: element.code,
            value_type: element.value_type,
            is_null: element.is_null,
            data_source: element.data_source,
          });
        }

        try {
          if (this.item.Payload != "") {
            JSON.parse(this.item.Payload); // 如果不是json字符串就会抛异常
          }
        } catch (e) {
          this.$message({
            type: "warning",
            message: "命令内容JSON格式错误:" + e,
            duration: 1500,
          });
          return;
        }

        //有额外参数的情况下，额外参数索引不能为空
        if (
          this.item.ExtraParams != null &&
          this.item.ExtraParams.length > 0 &&
          this.item.ExtraIndex === ""
        ) {
          // this.$message({
          //   type: "warning",
          //   message: "额外参数索引不能为空",
          //   duration: 1500,
          // });
          // return;
          this.$confirm("额外参数索引为空，确定继续保存？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.submitting = true;
              this.$emit("input", this.item);
              const itemData = { ...this.item };
              itemData.BusinessGroup = parseInt(itemData.BusinessGroup);
              // 保存的操作
              this.$axios
                .request({
                  url: this.item.ID ? `command/${itemData.ID}` : "command",
                  method: itemData.ID ? "put" : "post",
                  data: itemData,
                })
                .then(() => {
                  this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
                  this.submitting = false;
                  this.$emit(
                    itemData.ID ? "form:updated" : "form:created",
                    true
                  );
                  this.$emit("form:saved", true);
                  this.$emit("update:visible", false);
                })
                .catch(({ response }) => {
                  this.$sys.alarmResponse(response);
                  this.submitting = false;
                  this.$emit(
                    itemData.ID ? "form:updated" : "form:created",
                    false
                  );
                  this.$emit("form:saved", false);
                });
            })
            .catch(() => {});
        }else{
          this.submitting = true;
              this.$emit("input", this.item);
              const itemData = { ...this.item };
              itemData.BusinessGroup = parseInt(itemData.BusinessGroup);
              // 保存的操作
              this.$axios
                .request({
                  url: this.item.ID ? `command/${itemData.ID}` : "command",
                  method: itemData.ID ? "put" : "post",
                  data: itemData,
                })
                .then(() => {
                  this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
                  this.submitting = false;
                  this.$emit(
                    itemData.ID ? "form:updated" : "form:created",
                    true
                  );
                  this.$emit("form:saved", true);
                  this.$emit("update:visible", false);
                })
                .catch(({ response }) => {
                  this.$sys.alarmResponse(response);
                  this.submitting = false;
                  this.$emit(
                    itemData.ID ? "form:updated" : "form:created",
                    false
                  );
                  this.$emit("form:saved", false);
                });
        }
      });
    },

    //点击新增额外参数按钮
    onCreateParamsClick() {
      this.paramsItem = this.getEmptyParamsItem();
      this.paramsVisible = true;
    },

    //编辑额外参数
    onEditParamsClick(row) {
      this.paramsItem = this.getEmptyParamsItem();

      this.paramsItem.id = row.id;
      this.paramsItem.key_cn = row.key_cn;
      this.paramsItem.key_en = row.key_en;
      this.paramsItem.code = row.code;
      this.paramsItem.value_type = row.value_type;
      this.paramsItem.is_null = row.is_null;
      this.paramsItem.data_source = row.data_source;

      this.paramsItem.data_sourcestr =
        row.data_source.length === 0 ? "" : JSON.stringify(row.data_source);
      this.paramsVisible = true;
    },

    //确认新增/保存额外参数
    onConfirmParamsItem() {
      this.$refs.paramsItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$emit("input", this.paramsItem);
        let itemData = { ...this.paramsItem };

        let isHave = false;
        this.paramsList.forEach((element) => {
          if (
            element.key_cn === itemData.key_cn &&
            element.id !== itemData.id
          ) {
            isHave = true;
          }
        });
        if (isHave) {
          this.$message({
            type: "warning",
            message: "显示名称不能重复",
            duration: 1500,
          });
          return;
        }

        isHave = false;
        this.paramsList.forEach((element) => {
          if (
            element.key_en === itemData.key_en &&
            element.id !== itemData.id
          ) {
            isHave = true;
          }
        });
        if (isHave) {
          this.$message({
            type: "warning",
            message: "参数名称不能重复",
            duration: 1500,
          });
          return;
        }

        if (itemData.data_sourcestr !== "") {
          try {
            itemData.data_source = JSON.parse(itemData.data_sourcestr); // 如果不是json字符串就会抛异常
          } catch (e) {
            this.$message({
              type: "warning",
              message: "数据源JSON格式错误:" + e,
              duration: 1500,
            });
            return;
          }
        } else {
          itemData.data_source = [];
        }

        //新增参数
        if (itemData.id === 0) {
          this.maxNum += 1;
          itemData.id = this.maxNum;
          this.paramsList.push(itemData);
        } else {
          for (let index = 0; index < this.paramsList.length; index++) {
            if (this.paramsList[index].id === itemData.id) {
              this.$set(this.paramsList, index, itemData);
              break;
            }
          }
        }

        this.paramsVisible = false;
      });
    },

    //删除额外参数
    onDeleteParams(row) {
      this.$confirm("确定要删除该参数吗？", "提示")
        .then(() => {
          for (let index = 0; index < this.paramsList.length; index++) {
            const element = this.paramsList[index];
            if (element.id === row.id) {
              this.paramsList.splice(index, 1);
              break;
            }
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },

    getEmptyParamsItem() {
      return {
        id: 0,
        key_cn: "", //显示名称
        key_en: "", //参数名称
        code: "", //参数编码
        value_type: "input", //参数类型
        is_null: false, //是否必填（默认是），（数据库字段是否允许null，和字面意思相反）
        data_source: [], //数据源
        data_sourcestr: "", //数据源_字符串格式
      };
    },

    onCloseParamsItem() {
      this.paramsVisible = false;
      this.$refs.paramsItemForm.resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>
